
define('tpl!taoQtiItem/qtiRunner/tpl/inlineModalFeedbackPreviewButton', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<li class=\"small btn-info action action-button rgt\" id=\"preview-feedback-ok-button\">\n    <a class=\"li-inner\" href=\"#\">\n        <span class=\"label\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "OK", options) : helperMissing.call(depth0, "__", "OK", options)))
    + "</span>\n    </a>\n</li>";
  return buffer;
  });
});

